/** Нажатия кадра — биты. Контракт между вводом, сетью и миром: по сети ходит ровно это число. */
export const BUTTON = {
  up: 1,
  down: 2,
  left: 4,
  right: 8,
  lightPunch: 16, // □
  heavyPunch: 32, // △
  lightKick: 64, // ✕
  heavyKick: 128, // ○
  block: 256, // блок: R2 на геймпаде (Джон 04.11.2026, 23:27: «Блок… должен быть на R2»), O на клавиатуре
  enhance: 512, // R2 — второй курок суперприёма (вместе с блоком)
  super: 1024, // L2; суперприём — L2 + R2 вместе, в окне SUPER_WINDOW кадров
  taunt: 2048, // издёвка: тачпад DualSense, T на клавиатуре (Джон 04.11.2026, 22:29)
  grab: 4096, // захват: L1 вплотную, H на клавиатуре (Джон 04.11.2026, 23:26: «Вперёд + L1»)
} as const;

export type InputBits = number;

export type AttackButton = "lightPunch" | "heavyPunch" | "lightKick" | "heavyKick";
export const ATTACK_BUTTONS: readonly AttackButton[] = ["lightPunch", "heavyPunch", "lightKick", "heavyKick"];

/** Направление от лица героя: F — к сопернику, B — от него. Числа — для истории ввода в снимке. */
export const DIRECTION = { N: 0, F: 1, B: 2, D: 3, U: 4, DF: 5, DB: 6, UF: 7, UB: 8 } as const;
export type DirectionName = keyof typeof DIRECTION;

export function relativeDirection(bits: InputBits, facing: number): number {
  const horizontal = (bits & BUTTON.right ? 1 : 0) - (bits & BUTTON.left ? 1 : 0);
  const forward = horizontal * facing;
  const down = (bits & BUTTON.down) !== 0;
  const up = (bits & BUTTON.up) !== 0 && !down;
  if (down) return forward > 0 ? DIRECTION.DF : forward < 0 ? DIRECTION.DB : DIRECTION.D;
  if (up) return forward > 0 ? DIRECTION.UF : forward < 0 ? DIRECTION.UB : DIRECTION.U;
  return forward > 0 ? DIRECTION.F : forward < 0 ? DIRECTION.B : DIRECTION.N;
}
